import Service from './Service';

/**
 * 钱包模块接口
 */
class WalletService extends Service {
    /**
     * 查询钱包信
     */
    queryWalletInfo() {
        return this.axios.get('api/pay/v1/wallet/balance/detail');
    }
    /**
     * 查询授信信息
     */
    queryCreditInfo() {
        return this.axios.get('api/pay/v1/wallet/credit/detail');
    }
    /**
     * 查询授信历史
     * @param params
     */
    queryCreditHistory(params) {
        return this.axios.get('api/pay/v1/wallet/credit/history', {
            params
        });
    }
    /**
     * 查询钱包交易记录
     * @param params
     */
    queryTrades(params) {
        return this.axios.get('api/pay/v1/trade/wallet/list', {
            params
        });
    }
    /**
     * 查询交易详情
     * @param busiSn
     */
    queryTradeDetail(busiSn) {
        return this.axios.get(`api/pay/v1/trade/wallet/current/${busiSn}/detail`);
    }
    /**
     * 修改钱包详情
     * @param params
     */
    modifyWalletInfo(params) {
        return this.axios.put(`api/pay/v1/wallet/modify/pwd`, params);
    }
    /**
     * 发送验证码
     * @param params
     */
    sendSms(params) {
        return this.axios.post('api/pay/v1/captcha', params);
    }
    /**
     * 获取手机号
     */
    getPhone(params) {
        return this.axios.get('api/pay/v1/trade/phone');
    }
    /**
     * 获取手机号
     */
    getJsbPhone(params) {
        return this.axios.get('api/pay/v1/jsb/trade/phone');
    }
    /**
     * 零钱转授信
     * @param params
     */
    postTradeWalletCredit(params) {
        return this.axios.post('api/pay/v1/trade/walletCredit', params);
    }
    /**
     * 结算宝钱包转授信
     * @param params
     */
    postTradeJsbWalletCredit(params) {
        return this.axios.post('api/pay/v1/trade/jsbWallet2Credit', params);
    }
    /**
     * 获取修改密码的验证码
     */
    getWalletPasswordCaptcha() {
        return this.axios.get('api/pay/v1/wallet/password/captcha');
    }
    /**
     * 修改企业钱包的密码
     */
    putWalletPassword(params) {
        return this.axios.put('api/pay/v1/wallet/password', params);
    }
    /**
     * 查询商户联系人信息
     */
    getContactInfo() {
        return this.axios.get('api/pay/v1/wallet/account/setting/info');
    }
    /**
     * 修改商户手机号
     */
    putTelephone(params) {
        return this.axios.put('api/pay/v1/wallet/telephone', params);
    }
    /**
     * 发送验证码
     */
    sendCode(params) {
        return this.axios.get('api/pay/v1/function/sendSMS', {
            params
        });
    }
    /**
     * 查询当前用户的钱包
     */
    getMerchantdetail() {
        return this.axios.get('api/pay/v1/wallet/merchant/detail');
    }
    /**
     * 查询银行行名行号
     */
    queryBank(params) {
        return this.axios.get('api/pay/v1/function/queryBank', {
            params
        });
    }
    /**
     * 查询银行行名行号
     */
    putBankAccount(params) {
        return this.axios.put('api/pay/v1/wallet/bankAccount', params);
    }
    /**
     * 钱包信息查询
     */
    getWalletInfo() {
        return this.axios.get('api/pay/v1/merchant/wallet/info');
    }
    /**
     * 钱包提现
     */
    getWalletWithdraw(params) {
        return this.axios.post('api/pay/v1/merchant/wallet/account/withdraw',params);
    }
}

const walletService = new WalletService();
export default walletService;
